import './OpportunityMetadata.scss';

import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment/moment";

export default class OpportunityMetadata extends React.Component {
    static propTypes = {
        allowsRemote: PropTypes.bool,
        duration: PropTypes.string,
        endDate: PropTypes.string,
        location: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired
    };

    render() {
        return (
            <div className="c-opportunity-metadata">
                <div className="c-opportunity-metadata__posting-location">
                    {this.props.location != null ? <span>Location: <strong>{this.props.location}</strong></span> : ''} {this.props.allowsRemote === true ? <span>(Remote OK)</span> : null}
                </div>
                <div className="c-opportunity-metadata__posting-start-date">
                    | Starts: <strong>{moment(this.props.startDate).format('MMM D')}</strong>
                </div>
                {this.props.endDate != null ? (
                    <div className="c-opportunity-metadata__posting-end-date">
                        | Ends: <strong>{moment(this.props.endDate).format('MMM D')}</strong>
                    </div>
                ) : null}
                {this.props.duration != null ? (
                    <div className="c-opportunity-metadata__posting-duration">
                        | Duration: <strong>{this.props.duration}</strong>
                    </div>
                ) : null}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Opportunities/components/OpportunityMetadata/index.js